import { render, staticRenderFns } from "./billCertList.vue?vue&type=template&id=2e7ee314"
import script from "./billCertList.vue?vue&type=script&lang=js"
export * from "./billCertList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports